import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import PartnerSharesHeader from './components/PartnerSharesHeader';
import PartnerSharesBody from './components/PartnerSharesBody';
import { usePartnerShares } from './context/PartnerSharesContext';

type PartnerSharesProps = {
  compact?: boolean;
};

const PartnerShares: FC<PartnerSharesProps> = ({ compact = false }) => {
  const { data } = usePartnerShares();
  return (
    <>
      <PartnerSharesHeader />
      <PartnerSharesBody compact={compact} />

      {data.isLoading && <CustomLoading />}
    </>
  );
};
export default PartnerShares;
